export default async truckBuild => { // 'comp-truck-hero + [build]'
	const videoElements = [...truckBuild.querySelectorAll('video')];
	if(videoElements.length < 1) return;
	const 	{default: ScrollMagic} = await import('scrollmagic'),
			controller = new ScrollMagic.Controller(),
			videos = [];
	
	Promise.all(videoElements.map(video => {
		readyVideo({video,videos});
		
		return new Promise((resolve, reject) => {
			let  req = new XMLHttpRequest();
			req.open('GET', video.src, true);
			req.responseType = 'blob';
			req.onload = () => {
				video.src = URL.createObjectURL(req.response);
				readyVideo({video,videos}).then(resolve);
			}
			req.onerror = reject;
			req.send();
		});
	})).then(() => {
		videos.forEach(({video,dur}) => {
			(new ScrollMagic.Scene({triggerElement: video, triggerHook: 1}))
				.addTo(controller)
				.duration(window.innerHeight + video.clientHeight)
				.on("progress", (e) => video.currentTime = dur * e.progress);
		});
	});
};

function readyVideo({video,videos}){
	return new Promise(resolve => {
		const interval = setInterval(() => {
			if(video.readyState > 0) {
				videos.push({video,dur:video.duration});
				video.pause();
				clearInterval(interval);
				resolve(video);
			}
		}, 200);
	});
}